import React from "react";

import { Column } from "../../../utils/models";
import { InfraredResult } from "../../forms/custom-infrared/infraredResultForm";
import { getOptimizedImageURL, preventImageCaching } from "../../../utils/utilities";

import CustomSection from "../custom-general/custom-section";
import PDFTablePage from "../../themed/pdf/pdfTablePage";
import PDFImage from "../../themed/pdf/pdfImage";

interface Props {
    data: InfraredResult[];
}

const InfraredResultReport: React.FC<Props> = ({ data }) => {
    return ( 
        <>
            {data.map((datum) => (
                <CustomSection key={datum.imagingLocation} sectionTitle="Result" >
                    <div className="p-1">
                        <PDFTablePage data={[datum]} columns={columns} />
                    </div>

                    <PDFImage
                        refNo={datum.scanImage[0].refNo}
                        src={preventImageCaching(getOptimizedImageURL(datum.scanImage[0].src))}
                        caption="SCAN IMAGE"
                    />
                </CustomSection>
            ))}
        </>
    );
};

const columns: Column[] = [
    {
        path: 'imagingLocation',
        label: 'Imaging Location',
    },
    {
        path: 'elevation',
        label: 'Elevation',
    },
    {
        path: 'suspectedSedimentLevel',
        label: 'Suspected Sediment Level (Cm)',
    },
    {
        path: 'calculatedDepositVolume',
        label: 'Calculated Volume of Sediment Deposit (m3)',
    },
    {
        path: 'maxTemperature',
        label: 'Max Temperature (C)',
    },
    {
        path: 'minTemperature',
        label: 'Min Temperature (C)',
    },
];
 
export default InfraredResultReport;